import { Button, Heading, LuIcon, Text } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { ViewContainer } from "../../components/Containers/ViewContainer"
import { modelIconMapping } from "../../mappings/icons"

export const NotFound = memo(() => {
	return (
		<ViewContainer maxWidth="4xl">
			<div className="flex size-full items-center justify-center">
				<div className="flex flex-col items-center gap-2">
					<Heading size="xl">Project not found</Heading>
					<Text>The requested project does not exist</Text>
					<Link from="/$organizationId/$projectId" to="/$organizationId/projects">
						<Button variant="ghost">
							<LuIcon icon={modelIconMapping.arrowLeft} />
							Back to projects
						</Button>
					</Link>
				</div>
			</div>
		</ViewContainer>
	)
})
NotFound.displayName = "NotFound"
